<div class="clinician-index-hero" [class.pb-16]="(consultationPopup.shouldShowPopup$ | async)">

  <div class="w-full flex flex-col">
    <app-header></app-header>
  </div>
  <div class="shell-frame">
    <app-sidebar
      [sidebarItems]="primarySidebarItems"
      [footerAction]="adminEntryPoint"
      [inactivePrefixes]="primarySidebarInactivePrefixes">
    </app-sidebar>

    @if (showAdminRail && adminSidebarItems.length) {
      <app-sidebar
        variant="secondary"
        [sidebarItems]="adminSidebarItems">
      </app-sidebar>
    }

    <main class="relative flex-1 min-w-0 overflow-hidden">
      <router-outlet></router-outlet>
      <div class="absolute bottom-0 left-0 right-0">
        <app-appointment-ribbon></app-appointment-ribbon>
      </div>
    </main>
  </div>
</div>
